import { locationResultsConstants } from '../_constants';

const defaultState = {
  casual: [],
  casualLoading: false,
  error: false,
};
export function locationResults(state = defaultState, action) {
  switch (action.type) {
    case locationResultsConstants.GET_CASUAL_RESULTS_REQUEST:
      return {
        ...state,
        error: false,
        casualLoading: true,
      };

    case locationResultsConstants.GET_CASUAL_RESULTS_ERROR:
      return {
        ...state,
        error: true,
        casualLoading: false,
      };

    case locationResultsConstants.GET_CASUAL_RESULTS_SUCCESS:
      return {
        ...state,
        error: false,
        casualLoading: false,
        casual: action.data,
      };
    case locationResultsConstants.DELETE_RESULT_SUCCESS:
      const results = state.casual.filter((r) => r.id !== action.data);
      return {
        ...state,
        casual: results,
      };
    default:
      return state;
  }
}
